import React from 'react';
import { useSelector } from 'react-redux';
import Movie from '../components/Movie/Movie';
import Nav from '../components/Nav/Nav';
import TvMain from '../components/Main/TvMain';

const TvShows = () => {
  const tvPopular = useSelector((state) => state.tvPopular);
  const tvTopRated = useSelector((state) => state.tvTopRated);
  // const tvLatest = useSelector((state) => state.tvLatest);
  const tvAiringToday = useSelector((state) => state.tvAiringToday);
  const tvOnAir = useSelector((state) => state.tvOnAir);
  const tvUpcoming = useSelector((state) => state.upComing);
  const tvActionAndAdventure = useSelector((state) => state.tvActionAndAdventure);
  const tvAnimation = useSelector((state) => state.tvAnimation);
  const tvComedy = useSelector((state) => state.tvComedy);
  const tvCrime = useSelector((state) => state.tvCrime);
  const tvDocumentary = useSelector((state) => state.tvDocumentary);
  const tvDrama = useSelector((state) => state.tvDrama);
  const tvFamily = useSelector((state) => state.tvFamily);
  const tvKids = useSelector((state) => state.tvKids);
  const tvMystery = useSelector((state) => state.tvMystery);
  const tvNews = useSelector((state) => state.tvNews);
  const tvReality = useSelector((state) => state.tvReality);
  const tvSciFiAndFantasy = useSelector((state) => state.tvSciFiAndFantasy);
  const tvSoap = useSelector((state) => state.tvSoap);
  const tvTalk = useSelector((state) => state.tvTalk);
  const tvWarAndPolitics = useSelector((state) => state.tvWarAndPolitics);
  const tvWestern = useSelector((state) => state.tvWestern);
  const tvTrending = useSelector((state) => state.tvTrending);

  return (
    <>
      <Nav />
      <TvMain />
      <div className="all-movies">
        <div className="main-movie-section flixfrenzy-originals">
          <Movie fetchUrl={tvTrending} title="Trending" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvPopular} title="Popular" />
        </div>
        <div className="main-movie-section">
          <Movie fetchUrl={tvTopRated} title="Top Rated" />
        </div>

        {/* <div className="main-movie-section">
          <Movie fetchUrl={tvLatest}  title="Latest" />
        </div> */}

        <div className="main-movie-section">
          <Movie fetchUrl={tvAiringToday} title="Airing Today" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvOnAir} title="On Air" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvUpcoming} title="Upcopming" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvActionAndAdventure} title="Adventure" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvAnimation} title="Animation" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvDrama} title="Drama" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvFamily} title="Family" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvKids} title="Kids" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvReality} title="Reality" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvSoap} title="Soap" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvTalk} title="Talk" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvComedy} title="Comedy" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvDocumentary} title="Documentary" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvCrime} title="Crime" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvMystery} title="Mystery" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvNews} title="News" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvSciFiAndFantasy} title="Sci-Fi And Fantasy" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvWarAndPolitics} title="War And Politics" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvWestern} title="Western" />
        </div>
      </div>
    </>
  );
};

export default TvShows;
